import { Button } from '@connected/ui/components/button';
import { Popout, PopoutContent, PopoutHeader, PopoutTitle } from '@connected/ui/components/popout';
import { useStore } from '@tanstack/react-store';

import { confirmerStore, handleConfirm } from '@/stores/confirmer';

// Component
export function Confirmer() {
    const { isOpen, title, isDanger } = useStore(confirmerStore);

    return (

        <Popout
            open={isOpen}
            onOpenChange={(open) => {
                if (!open) {
                    handleConfirm(false);
                }
            }}

        >
            <PopoutContent>
                <PopoutHeader>
                    <PopoutTitle>{title}</PopoutTitle>
                </PopoutHeader>
                <Popout.Body className="flex flex-col gap-4 py-6">
                    <Button
                        type="button"
                        variant={isDanger ? 'destructive' : 'outline'}
                        className="p-5"
                        onClick={() => handleConfirm(!!isDanger)}
                    >
                        {/* HACK: Create: translation(s) */}
                        {isDanger ? 'Bevestig' : 'Annuleer'}
                    </Button>
                    <Button
                        type="button"
                        variant="success"
                        className="p-5"
                        onClick={() => handleConfirm(!isDanger)}
                    >
                        {/* HACK: Create: translation(s) */}
                        {isDanger ? 'Annuleer' : 'Bevestig'}
                    </Button>
                </Popout.Body>
            </PopoutContent>
        </Popout>
        // <Dialog

    // >
    //     <DialogContent className="z-[100]">
    //         <DialogHeader className="flex-shrink-0 gap-0">
    //             <DialogTitle className="text-xl text-center whitespace-pre-line">
    //                 {title}
    //             </DialogTitle>
    //             <DialogDescription>
    //             </DialogDescription>
    //         </DialogHeader>
    //         <div className="flex flex-col gap-4 pt-4">
    //             <Button
    //                 type="button"
    //                 variant={isDanger ? 'destructive' : 'outline'}
    //                 className="p-5"
    //                 onClick={() => handleConfirm(!!isDanger)}
    //             >
    //                 {/* HACK: Create: translation(s) */}
    //                 {isDanger ? 'Bevestig' : 'Annuleer'}
    //             </Button>
    //             <Button
    //                 type="button"
    //                 variant="success"
    //                 className="p-5"
    //                 onClick={() => handleConfirm(!isDanger)}
    //             >
    //                 {/* HACK: Create: translation(s) */}
    //                 {isDanger ? 'Annuleer' : 'Bevestig'}
    //             </Button>
    //         </div>
    //     </DialogContent>
    // </Dialog>
    );
}
